import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

import { useParams } from "react-router";

import { Link } from "react-router-dom";
import { getGameById, putGame, gameCall } from "services/game_service";
import { getTeamMembers } from "services/teams_service";

import _ from "lodash";

function App() {
  const { gameId } = useParams();
  const navigate = useNavigate();

  const [members, setMembers] = useState([]);
  const [playersIdList, setPlayerListId] = useState([]);
  const [game, setGame] = useState({});

  useEffect(() => {
    async function getTeamsFunc() {
      try {
        const memList = await getGameById(gameId);
        setGame(memList);
        
        const memberList = await getTeamMembers(
          memList.attributes.team.data.id
        );

        const players = memberList.filter(
          (el) => el.attributes.role === "Jogador"
        );
        
        setPlayerListId(memList.attributes.players.data.map((el) => el.id));
        setMembers(players);
      } catch (exception) {
        console.log("exception: ", exception);
      }
    }

    getTeamsFunc();
  }, []);

  const addPlayer = (playerId) => {
    if (!_.includes(playersIdList, playerId)) {
      setPlayerListId([...playersIdList, playerId]);
      return;
    }

    const playersList = _.without(playersIdList, playerId)
    setPlayerListId(playersList);
  };

  const submitConvocatoria = async (data) => {
    await putGame(gameId, {players: playersIdList, call_status: 'sending'});
    
    await gameCall(gameId);
    navigate(`/jogos/${gameId}`);
  };

  const saveConvocatoria = async () => {
    await putGame(gameId, {players: playersIdList});
    navigate(`/jogos/${gameId}`);
  }

  const isConvocatoriaSubmited = () => {
    return game && game.attributes && game.attributes.call_status !== 'draft';
  }

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
          <TopAdd></TopAdd>
          <div style={{"display": "flex"}}>

          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <Link to={"/equipas"}>Plantel</Link>/ Detalhe
              </ul>
            </nav>

            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">Convocatória para o jogo</h1>
                  </div>
                </div>
              </div>
            </div>

            <h2>Jogadores</h2>
              <table className="table fullwidth">
                <thead>
                  <tr>
                    <th>
                      <abbr title="Position">Convocado</abbr>
                    </th>
                    <th>
                      <abbr title="Position">Nome</abbr>
                    </th>
                    <th>
                      <abbr title="Played">Posição</abbr>
                    </th>
                    <th>
                      <abbr title="Won">Peso (kg)</abbr>
                    </th>
                    <th>
                      <abbr title="Won">Altura (cm)</abbr>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {members.map((el, idx) => (
                    <tr key={idx}>
                      <td>
                        <input
                          type="checkbox"
                          disabled={isConvocatoriaSubmited()}
                          checked={_.includes(playersIdList, el.id)}
                          onChange={(e) => {
                            addPlayer(el.id);
                          }}
                        ></input>
                      </td>
                      <td>{el.attributes.name}</td>
                      <td>{el.attributes?.position?.join(", ")}</td>
                      <td>{el.attributes.age}</td>
                      <td>{el.attributes.height}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
         
              <button onClick={() => saveConvocatoria()} className="button">Gravar</button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <button disabled={isConvocatoriaSubmited()} onClick={() => submitConvocatoria()} className="button">Enviar convocatoria</button>
              <br></br>
              <br></br>
              * Ao enviar a convocatoria irá ser enviado um email aos jogadores selecionados. Não poderá alterar a convocatoria após ser enviada.

          </section>
          <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}

export default App;
